module.exports = __webpack_public_path__ + "img/solution-tool-system-pic-2.bbccc995.png";